import React, { useEffect, useState, Fragment } from 'react';
import Container from 'react-bootstrap/Container'
import Card from 'react-bootstrap/Card'
import {  useDispatch } from 'react-redux';
import FormularioPrincipal from './formularios'
import { useLocation } from 'react-router-dom'
import { configuracionFormAction8} from "../../store/actions/encargado-cia-action";
import { Auth } from 'recupero-comunes'
import { CasoGeneralComponent } from 'reccol-caso-general'

const PrepararCartaCobro = () => {
 const {  rutOrganizacion } = Auth.currentUser()
 const {state}=useLocation()
 const dispatch=useDispatch()
 const idCasoLocation=state?.row?.IdCaso ? state.row.IdCaso:14
 const idImplicado=state?.row?.IdImplicado ? state.row.IdImplicado:1
 const idOrganizacionCaso =state?.row?.idOrganizacionCaso  ? state.row.idOrganizacionCaso:8600399880
 const [datosCaso, setDatosCaso] = useState(null);

  useEffect(() => {
    // @TODO: reemplazar valor estáticos.
    let query = Buffer.from(JSON.stringify({ "idform": 8, "rutcia": rutOrganizacion })).toString('base64');
    dispatch(configuracionFormAction8(query));

}, [dispatch]);
 
  return (
    <Container>
      <Container>
            <Card className='mt-2'>
                <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >
                {`Iniciar Recobro entre Compañías, Caso: ${idCasoLocation}`}
                </Card.Header>
                <Card.Body>
                    <CasoGeneralComponent idCaso={idCasoLocation} idImplicado={idImplicado} idOrganizacionCaso={idOrganizacionCaso} setDatosCaso={setDatosCaso}/>                     
                </Card.Body>
            </Card>      
           <FormularioPrincipal 
              datosCaso={datosCaso}            
           />
        </Container>                 
    </Container>
  )
}
export default PrepararCartaCobro
